import { useMemo } from "react";
import { Button, Modal } from "react-bootstrap";
import ClocksData from "./clocks/ClocksData";
import { useResolvedModules } from "./HelperHooks";

export default function ClocksModal({
    show,
    handleClose,
    radioId,
    date,
    hour,
    addToCollectionAllowed,
    startAudioTime = 0,
    fromContentTesting = false,
    formData = [],
}) {
    const resolvedModules = useResolvedModules();
    const clocksEnabled = useMemo(() => resolvedModules?.includes(1), [resolvedModules]);
    const handleOpenInClocks = () => {
        const station = formData.station?.[0];
        if (!station) return;

        let demoToSet = [];
        if (station.stream) {
            demoToSet = [{ demo_id: 1, name: "All", data_type: 1, listener_group: 0, data_demo_id: 0, ppm_area_id: null, music_test: true }];
        } else if (station.ppm) {
            demoToSet = [{ demo_id: 8, name: "All", data_type: 2, listener_group: 0, data_demo_id: 0, ppm_area_id: -1, music_test: true }];
        }

        const newFormData = {
            ...formData,
            date,
            hour,
            radioId,
            data_type: station.stream ? 1 : 2,
            demo: demoToSet,
            extraStation0: formData.extraStation0 || [],
            extraStation1: formData.extraStation1 || [],
            extraDemo0: formData.extraDemo0 || [],
            extraDemo1: formData.extraDemo1 || [],
        };
        localStorage.setItem("clocksFromModal", JSON.stringify(newFormData));
        window.open("/client/clocks", "_blank");

        handleClose();
    };

    return (
        <Modal centered show={show && clocksEnabled} onHide={handleClose} className="clocks-modal">
            <Modal.Body>
                <ClocksData
                    radioId={radioId}
                    demo={[]}
                    secondary
                    date={date}
                    hour={hour}
                    addToCollectionAllowed={addToCollectionAllowed}
                    startAudioTime={startAudioTime}
                />
            </Modal.Body>
            <Modal.Footer>
                {fromContentTesting && (
                    <Button variant="ra-yellow" size="sm" onClick={handleOpenInClocks}>
                        Open in Clocks
                    </Button>
                )}

                <Button variant="ra-yellow" size="sm" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
